module.exports = __webpack_public_path__ + "media/icons/wlasciciel-firma-blue@2x-e452d4f4.png";